// extracted by mini-css-extract-plugin
export var btn = "index-module--btn--GhBAV";
export var buttons = "index-module--buttons--ZRzrT";
export var content = "index-module--content--2SEGO";
export var headerWrapper = "index-module--headerWrapper--+4mMU";
export var icon = "index-module--icon--JBUzB";
export var logo = "index-module--logo--jEb-R";
export var menu = "index-module--menu--Oi0FK";